import './index.css'
import type { DbCoupleInvite } from '../../types'
import { getToastErrorMessage, useToast } from '../Toast'

interface CoupleInviteBannerProps {
  pendingInvite: DbCoupleInvite | null
  onGoToSettings: () => void
  onCancelInvite: () => Promise<void> | void
}

function daysUntil(isoDate: string): number {
  return Math.max(0, Math.ceil((new Date(isoDate).getTime() - Date.now()) / 86_400_000))
}

export default function CoupleInviteBanner({ pendingInvite, onGoToSettings, onCancelInvite }: CoupleInviteBannerProps) {
  const toast = useToast()

  function handleGoToSettings() {
    onGoToSettings()
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.getElementById('invite-partner-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    })
  }

  async function handleCancelInvite() {
    try {
      await onCancelInvite()
      toast.success('Convite cancelado.')
    } catch (err) {
      toast.error(getToastErrorMessage(err, 'Erro ao cancelar convite.'))
    }
  }

  if (pendingInvite) {
    return (
      <div className="bc-couple-banner bc-couple-banner--pending">
        <div className="bc-couple-banner__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <div className="bc-couple-banner__body">
          <p className="bc-couple-banner__title">Aguardando seu parceiro(a)</p>
          <p className="bc-couple-banner__desc">
            Convite enviado para <strong>{pendingInvite.invitee_email}</strong>. Expira em {daysUntil(pendingInvite.expires_at)} dia(s).
          </p>
        </div>
        <button
          className="bc-couple-banner__cta bc-btn bc-btn--secondary"
          onClick={handleCancelInvite}
        >
          Cancelar convite
        </button>
      </div>
    )
  }

  return (
    <div className="bc-couple-banner">
      <div className="bc-couple-banner__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
      <div className="bc-couple-banner__body">
        <p className="bc-couple-banner__title">Convide seu parceiro(a)</p>
        <p className="bc-couple-banner__desc">
          Você tem o plano Casal — conecte sua conta com a do seu parceiro e tenham uma visão completa das finanças juntos, em tempo real.
        </p>
      </div>
      <button
        className="bc-couple-banner__cta bc-btn bc-btn--primary"
        onClick={handleGoToSettings}
      >
        Conectar agora
      </button>
    </div>
  )
}
